import { Component } from '@angular/core';
import {
  GridWidgetSettings,
  IWidgetSettings,
} from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/widget-settings';
import { IntegrableFormParams } from '@common-modules/shared/forms/integrable-form';
import { GridConfiguration } from '@common-modules/shared/grid/grid-configuration';
import { globalUtilsHelper } from '@common-modules/shared/helpers/global-utils-helper';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { BaseDashboardSettingsComponent } from '../core/base-dashboard-settings.component';

class DashboardGridSettingsModel {
  gridName: string;
}

const COMPONENT_SELECTOR = 'ct-dashboard-grid-settings';
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './dashboard-grid-settings.component.html',
  styleUrl: './dashboard-grid-settings.component.scss',
  standalone: false,
})
export class DashboardGridSettingsComponent extends BaseDashboardSettingsComponent {
  initialModel: DashboardGridSettingsModel;
  gridConfiguration: GridConfiguration;
  formOptions: FormlyFormOptions = {};
  private _updatedSettings: GridConfiguration;
  private _widgetSettings: GridWidgetSettings;

  getWidgetSettings(): IWidgetSettings {
    return this._widgetSettings;
  }
  setParams(params: IntegrableFormParams): void {
    this.formOptions.formState.op = params.op;
    this.formOptions = globalUtilsHelper.clone(this.formOptions);
  }

  getModel() {
    return this._updatedSettings;
  }

  setInitialModel(model: GridWidgetSettings): void {
    this._widgetSettings = model;

    if (!model.gridConfiguration) {
      model.gridConfiguration = new GridConfiguration();
    }

    this.gridConfiguration = model.gridConfiguration;
    this.initialModel = this.settingsToModel(this.gridConfiguration);
    if (!this._updatedSettings) {
      this.onModelChange(this.initialModel);
    }
  }

  onModelChange(model: DashboardGridSettingsModel): void {
    this._updatedSettings = this.modelToSettings(model);
    this._widgetSettings.gridConfiguration = this._updatedSettings;
  }

  onIsValid(isValid: boolean): void {
    this.setIsValid(isValid);
  }

  onHasChanges(hasChanges: boolean): void {
    this.setHasChanges(hasChanges);
  }

  fieldConfig: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          key: 'gridName',
          type: 'input',
          className: 'col-10',
          props: {
            label: 'Title',
            required: true,
          },
        },
      ],
    },
  ];

  settingsToModel(settings: GridConfiguration): DashboardGridSettingsModel {
    if (!settings) {
      return null;
    }

    const model = {
      gridName: settings.gridName || '',
    };

    return model;
  }

  modelToSettings(model: DashboardGridSettingsModel): GridConfiguration {
    if (!model || !this.gridConfiguration) {
      return null;
    }

    this.gridConfiguration.gridName = model.gridName || '';

    return this.gridConfiguration;
  }
}
